import './App.css';
import { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom'
import CenteredLoader from './pages/CenteredLoader';
const Home = lazy(() => import('./pages/HomePage'))
const QuizPage = lazy(() => import('./pages/QuizPage'))
const GuideLinesPage = lazy(() => import('./pages/GuideLinesPage'))
const ThankYouPage = lazy(() => import('./pages/ThankYouPage'))
const LockedInputPage = lazy(() => import('./pages/LockedInputPage'))
function App() {
  return (
    <Suspense fallback={<CenteredLoader />}>
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>
        <Route path="/quiz" exact>
          <QuizPage />
        </Route>
        <Route path="/guidelines" exact>
          <GuideLinesPage />
        </Route>
        <Route path="/thankyou" exact render={(props) => <ThankYouPage {...props} />} />
        <Route path="/lockedpage" exact>
          <LockedInputPage />
        </Route>
      </Switch>
    </Suspense>
  );
}

export default App;
